import script from "./KillPigControl.vue?vue&type=script&setup=true&lang=ts"
export * from "./KillPigControl.vue?vue&type=script&setup=true&lang=ts"

import "./KillPigControl.vue?vue&type=style&index=0&id=b29b912c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b29b912c"]])

export default __exports__